import { createInertiaApp } from "@inertiajs/react";
import type { ResolvedComponent } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import "../styles/application.css";

// Vite needs a static glob so it can code-split the pages at build time.
const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.tsx");

createInertiaApp({
  progress: { color: "#0f172a" },

  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`];
    if (!page) {
      throw new Error(
        `Inertia page "${name}" not found. Expected app/frontend/pages/${name}.tsx`
      );
    }
    return page();
  },

  setup({ el, App, props }) {
    if (!el) throw new Error("Inertia root element missing");
    createRoot(el).render(<App {...props} />);
  },
});
